import React, { useState } from "react";
import { CheckCircle } from "./icons";
import { Photo } from "./photo";

export const Vehicle = ({ data }) => {
  const [main, setMain] = useState(0);
  if (!data) return null;

  const shots = [data.image, ...(data.gallery || [])];

  return (
    <section id="vehicule" className="vehicle-card">
      <div className="vehicle-head">
        <h2>{data.title}</h2>
        <p className="vehicle-sub">{data.subtitle}</p>
      </div>

      <div className="vehicle-body">
        <ul className="vehicle-features">
          {data.features.map((f) => (
            <li key={f}>
              <CheckCircle size={18} />
              <span>{f}</span>
            </li>
          ))}
        </ul>

        <Photo
          key={shots[main]}
          src={shots[main]}
          alt={`${data.title} ${data.subtitle}`}
          label="Photo véhicule"
          className="vehicle-photo"
        />
      </div>

      <div className="vehicle-gallery">
        {(data.gallery || []).map((src, i) => (
          <button
            type="button"
            key={src}
            className={`vehicle-thumb ${main === i + 1 ? "is-active" : ""}`}
            onClick={() => setMain(i + 1)}
            aria-label={`Voir la photo ${i + 1}`}
          >
            <Photo src={src} alt="" label="Photo" />
          </button>
        ))}
      </div>

      <button
        type="button"
        className="btn btn-dark vehicle-more"
        onClick={() => setMain((m) => (m + 1) % shots.length)}
      >
        Voir plus de photos
      </button>
    </section>
  );
};

export default Vehicle;
